import { useEffect } from 'react';
import { NextRouter } from 'next/router';

export default function useScrollRestoration(router: NextRouter) {
    useEffect(() => {
        const onBeforeUnload = () => {
            sessionStorage.removeItem('scrollPosition');
        };

        const handleRouteChange = () => {
            sessionStorage.setItem('scrollPosition', window.scrollY.toString());
        };

        const handleRouteChangeComplete = (url: string) => {
            if (!url.includes('/catalog/')) {
                sessionStorage.removeItem('scrollPosition');
            }
        };

        router.events.on('routeChangeStart', handleRouteChange);
        router.events.on('routeChangeComplete', handleRouteChangeComplete);
        window.addEventListener('beforeunload', onBeforeUnload);

        return () => {
            router.events.off('routeChangeStart', handleRouteChange);
            router.events.off('routeChangeComplete', handleRouteChangeComplete);
            window.removeEventListener('beforeunload', onBeforeUnload);
        };
    }, [router.events]);

    useEffect(() => {
        if ('scrollPosition' in sessionStorage) {
            window.scrollTo(0, Number(sessionStorage.getItem('scrollPosition')));
            sessionStorage.removeItem('scrollPosition');
        }
    }, []);
}
